var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['overlay-mask-container', _vm.openState ? 'open' : 'closed'],on:{"click":_vm.dismissOverlayMask}})}
var staticRenderFns = []

export { render, staticRenderFns }